package ru.chm.gradereport.ui.theme

enum class ThemeMode {
    System,
    Light,
    Dark,
    ;

    val storageKey: String
        get() = when (this) {
            System -> "system"
            Light -> "light"
            Dark -> "dark"
        }

    val label: String
        get() = when (this) {
            System -> "Системная"
            Light -> "Светлая"
            Dark -> "Тёмная"
        }

    companion object {
        val Default: ThemeMode = System

        fun fromStorage(value: String?): ThemeMode = when (value?.lowercase()) {
            "light" -> Light
            "dark" -> Dark
            "system" -> System
            else -> Default
        }
    }
}
